import { PaymentProcessorAccountConfigurationBase } from '../payment-processor-account-configuration-base';

export class InvoiceCloudPaymentProcessorAccountConfiguration extends PaymentProcessorAccountConfigurationBase {
  invoiceTypeId?: string; 
  billerGuid?: string; 

  constructor(
    options?: Partial<InvoiceCloudPaymentProcessorAccountConfiguration>
  ) {
    super(options);
    if (options) {
      Object.assign(this, options);
    }
  }
}